/* eslint-disable */

//import axios from "axios";

//const url = require("../../client_config/config").url;

const state = {
  items: [],
  dialog: false,
  loading: false,
  defaultPage: true,
  scheduledPage: false,
  outstandingPage: false,
  settingsPage: false,
  rhsPayroll: false,
  dateStart: "",
  dateEnd: "",
};

const getters = {};

const actions = {};

const mutations = {
  SET_RHSPAYROLL_PAGE(state, payload){
    state.rhsPayroll = payload;
  },
  SET_DEFAULT_PAGE(state, payload){
    state.defaultPage = payload;
  },
  SET_SCHEDULED_PAGE(state, payload){
    state.scheduledPage = payload;
  },
  SET_OUTSTANDING_PAGE(state, payload){
    state.outstandingPage = payload;
  },
  SET_SETTING_PAGE(state, payload){
    state.settingsPage = payload;
  },
  SET_DATE_START(state, payload){
    state.dateStart = payload;
  },
  SET_DATE_END(state, payload){
    state.dateEnd = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
